// Extrai os parâmetros da query string (`?chave=valor&...`) e do fragmento
// (`#chave=valor&...`) de uma URL — usado pelo deep link de recuperação de senha
// (ResetPasswordScreen), cobrindo tanto redirects de erro em query string quanto
// tokens de sessão de recovery em hash fragment ou query params.
export function parseFragmentParams(url: string): Record<string, string> {
  const params: Record<string, string> = {};

  const queryIndex = url.indexOf('?');
  const hashIndex = url.indexOf('#');

  // 1. Extrai query params (?chave=valor&...)
  if (queryIndex !== -1) {
    const queryString = hashIndex !== -1 && hashIndex > queryIndex
      ? url.slice(queryIndex + 1, hashIndex)
      : url.slice(queryIndex + 1);
    for (const pair of queryString.split('&')) {
      if (!pair) continue;
      const [key, value = ''] = pair.split('=');
      if (!key) continue;
      params[decodeURIComponent(key)] = decodeURIComponent(value.replace(/\+/g, ' '));
    }
  }

  // 2. Extrai hash fragment (#chave=valor&...)
  if (hashIndex !== -1) {
    for (const pair of url.slice(hashIndex + 1).split('&')) {
      if (!pair) continue;
      const [key, value = ''] = pair.split('=');
      if (!key) continue;
      params[decodeURIComponent(key)] = decodeURIComponent(value.replace(/\+/g, ' '));
    }
  }

  return params;
}
